import styled from 'styled-components';
import { LAYOUT } from '@app/styles/themes/constants';

export const Container = styled.div`
  padding: ${LAYOUT.desktop.paddingVertical} ${LAYOUT.desktop.paddingHorizontal};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  overflow-x: hidden;
  margin-top: 1.5rem;
`;
